const initialState = {
    assets: [],
    pagination: null,
    error: null,
    errMsg: '',
    loading: false,
    success: false,
}

const assetsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ASSET_UPLOAD_REQUEST':
            return {
                ...state,
                loading: true,
                success: false,
                error: null
            };
        case 'ASSET_UPLOAD_FILE_EXISTS':
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload
            };
        case 'ASSET_UPLOAD_SUCCESS':
            return {
                ...state,
                loading: false,
                success: true,
                error: null
            }
        case 'ASSET_UPLOAD_FAIL':
            return {
                ...state,
                loading: false,
                success: false,
                error: true,
                errMsg: action.payload
            }
        case 'GET_ASSETS':
            return {
                ...state,
                assets: action.payload,
                pagination: action.pagination
            };
        case 'ASSET_DELETE_SUCCESS':
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                assets: state.assets.filter(asset => asset._id !== action.payload.id)
            };
        case 'ASSET_UPDATE_SUCCESS':
            return {
                ...state,
                loading: false,
                success: true,
                error: null,
                assets: state.assets.map(asset =>
                    asset._id === action.payload._id ? action.payload : asset
                )
            };
        default:
            return state;
    }
}

export default assetsReducer;